import { Box, Text, theme, Image } from '@everlywell/ui-kit';
import React from 'react';
import renderRichText, {
  ContentfulRichText,
} from 'utils/contentful/renderRichText';
import { ImageType } from 'utils/types';

export interface ToolCardV2Props {
  toolCards: {
    title?: string;
    bgColor?: string;
    textColor?: string;
    body?: ContentfulRichText;
    desktopBackgroundImage?: ImageType;
  }[];
}

/**
 * ToolCardV2 is a component that displays a small card non-clickable with background color and text.
 * It is also possible to add a image to the card.
 * TextColor and Background color, as well the content, are defined in Contentful.
 */

const ToolCardV2: React.FC<ToolCardV2Props | null> = (props) => {
  if (!props || !props.toolCards) {
    return null;
  }

  const { toolCards } = props;

  return (
    <Box
      position="absolute"
      right={['unset', 12]}
      bottom={['-20px', '28px']}
      display={['flex', 'block']}
      gap={['10px', 'unset']}
    >
      {toolCards.map((item, index: number) => (
        <Box
          key={index}
          width={['100px', '170px']}
          height={['100px', '170px']}
          backgroundColor={item.bgColor}
          borderRadius="8px"
          marginBottom={['0', '15px']}
        >
          <Box
            display="flex"
            height="100%"
            flexFlow="column"
            justifyContent="space-between"
            overflow="hidden"
          >
            {item.body?.raw ? (
              <Text
                color={item.textColor || theme.colors.tints.white}
                fontSize={['3xl', '8xl']}
                fontWeight="medium"
                lineHeight={['3xl', '8xl']}
                paddingX={[2, 5]}
                paddingBottom={[2, 2]}
              >
                {renderRichText(item.body)}
              </Text>
            ) : null}
            <Text
              fontSize={['sm', 'xl']}
              color={item.textColor || theme.colors.tints.white}
              fontWeight="medium"
              paddingX={[2, 5]}
              paddingTop={[2, 5]}
              paddingBottom={[2, 2]}
            >
              {item.title}
            </Text>
            {item.desktopBackgroundImage ? (
              <Image
                src={
                  item.desktopBackgroundImage.gatsbyImageData.images.fallback
                    ?.src
                }
              />
            ) : null}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ToolCardV2;
